import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { buildUrl } from '@core/utils/url.utilities';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private readonly httpClient = inject(HttpClient);

  private readonly environmentService = inject(EnvironmentService);

  /**
   * Sends a request for contract information.
   * The backend retrieves user and organization data from context.
   *
   * @returns {Promise<boolean>} A promise that resolves to a boolean indicating the success or failure of the request.
   */
  public requestContractInformation(): Promise<boolean> {
    return lastValueFrom(
      this.httpClient.post<boolean>(
        buildUrl(this.environmentService.baseAdpHost, 'contract/contract-information'),
        {},
        {
          withCredentials: true,
        },
      ),
    );
  }
}
